<template>
  <el-dialog title="添加会员" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="addShopVipUserInfo" label-width="120px">
      <el-form-item label="会员名称" prop="vipName" required>
        <el-input v-model="addShopVipUserInfo.vipName" placeholder="必填，请填写会员名称" style="width:100%" />
      </el-form-item>
      <el-form-item label="会员电话" prop="vipTel" required>
        <el-input v-model="addShopVipUserInfo.vipTel" placeholder="必填，请填写会员电话" style="width:100%" />
      </el-form-item>
      <el-form-item label="性别" prop="sex" required>
        <el-select v-model="addShopVipUserInfo.sex" placeholder="必填，请选择性别" style="width:100%">
          <el-option v-for="item in addShopVipUserInfo.sexs" :key="item.statusCd" :label="item.name"
            :value="item.statusCd" />
        </el-select>
      </el-form-item>
      <el-form-item label="会员等级" prop="vipLevel" required>
        <el-select v-model="addShopVipUserInfo.vipLevel" placeholder="必填，请选择会员等级" style="width:100%">
          <el-option v-for="item in addShopVipUserInfo.vipLevels" :key="item.vipLevelId" :label="item.levelName"
            :value="item.vipLevelId" />
        </el-select>
      </el-form-item>
      <el-form-item label="会员生日" prop="birthday" required>
        <el-date-picker v-model="addShopVipUserInfo.birthday" type="date" placeholder="必填，请填写会员生日"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>
      <el-form-item label="开始时间" prop="startTime" required>
        <el-date-picker v-model="addShopVipUserInfo.startTime" type="date" placeholder="必填，请填写开始时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>
      <el-form-item label="结束时间" prop="endTime" required>
        <el-date-picker v-model="addShopVipUserInfo.endTime" type="date" placeholder="必填，请填写结束时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveShopVipUserInfo">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { saveShopVipUser, queryShopVipLevel } from '@/api/user/shopVipUserApi'
import { getDict } from '@/api/shop/shopApi'

export default {
  name: 'AddShopVipUser',
  data() {
    return {
      dialogVisible: false,
      addShopVipUserInfo: {
        vipId: '',
        vipName: '',
        vipTel: '',
        sex: '',
        vipLevel: '',
        birthday: '',
        startTime: '',
        endTime: '',
        vipLevels: [],
        sexs: []
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._listAddShopVipLevels()
      this.getSexDict()
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.clearAddShopVipUserInfo()
    },
    async getSexDict() {
      try {
        const { data } = await getDict('s_shop_vip_user', 'sex')
        this.addShopVipUserInfo.sexs = data
      } catch (error) {
        console.error('获取性别字典失败:', error)
      }
    },
    async saveShopVipUserInfo() {
      try {
        await this.$refs.form.validate()
        this.addShopVipUserInfo.shopId = getShopId()
        const res = await saveShopVipUser(this.addShopVipUserInfo)
        console.log(res)
        this.$message.success('添加成功')
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('添加会员失败:', error)
      }
    },
    clearAddShopVipUserInfo() {
      this.addShopVipUserInfo = {
        vipName: '',
        vipTel: '',
        sex: '',
        vipLevel: '',
        birthday: '',
        startTime: '',
        endTime: '',
        vipLevels: []
      }
    },
    async _listAddShopVipLevels() {
      const param = {
        page: 1,
        row: 50,
        shopId: getShopId()
      }
      try {
        const res = await queryShopVipLevel(param)
        this.addShopVipUserInfo.vipLevels = res.data
      } catch (error) {
        console.error('获取会员等级失败:', error)
      }
    }
  }
}
</script>